<script>
import {getCategoryFn} from "@/api/modules/common";

export default {
  name: "customCategory",
  data() {
    return {
      list: [],
      active: 0
    }
  },
  created() {
    this.getInitFn()

  },
  methods: {
    getInitFn() {
      getCategoryFn().then(({code, data}) => {
        if (code === 0 && data) {
          this.list = [
            {
              id: 0,
              name: '全部'
            },
            ...data
          ]
          const findIndex = this.list.findIndex(item => item.id == this.$route.query.categoryId)
          this.active = findIndex !== -1 ? findIndex : 0
          this.$emit('tabChange', findIndex !== -1 ? findIndex : 0)
        }
      })
    },
    tabChangeFn(event) {
      this.$emit('tabChange', this.list[event].id)
    }
  }
}
</script>

<template>
  <div class="customCategory">
    <van-tabs v-model="active" color="#FF5733" sticky title-active-color="#FF5733" @change="tabChangeFn">
      <van-tab v-for="item in list" :title="item.name" :key="item.id">
      </van-tab>
    </van-tabs>
  </div>
</template>

<style scoped lang="scss">

</style>